import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

export default function UnderConstruction({
  title = "En construccion",
  message = "Esta seccion aun se esta construyendo.",
}) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
      <Paper
        elevation={2}
        sx={{
          p: { xs: 3, md: 4 },
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
        }}
      >
        <Stack spacing={2} alignItems="center">
          <ConstructionIcon sx={{ fontSize: 48, color: "warning.main" }} />
          <Typography variant="h5" fontWeight={800}>
            {title}
          </Typography>
          <Typography color="text.secondary">{message}</Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
